import React from "react";
import { Empty } from "antd";
import styles from "./TopicWithRelatedPeople.module.scss";
import { SwitchBar } from "../components/SwitchBar/SwitchBar";
import { Img } from "../ImgV2/Img";
import { WaterfallFlowList } from "../components/WaterfallFlowList/WaterfallFlowList";
import { isBlank } from "imagica-corekit/dist/base/cutil/Extensions";
import { get, map } from "lodash";
export function TopicWithRelatedPeople(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.topicWithRelatedPeopleWrapper
  }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("p", {
    className: styles.title
  }, get(props, "topic_info.topic.topic_title", "")), /*#__PURE__*/React.createElement("p", {
    className: styles.summary
  }, get(props, "topic_info.topic.topic_summary", ""))), /*#__PURE__*/React.createElement(SwitchBar, {
    sliderCount: props.people_list.length
  }, map(props.people_list, function (person, pIndex) {
    var _person$related_perso;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.relatedPersonBox,
      key: pIndex
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.personInfo
    }, /*#__PURE__*/React.createElement(Img, {
      className: "topicWithRelatedPeoplePersonInfoImg",
      imgKey: get(person, "related_person.image", "")
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.personDetail
    }, /*#__PURE__*/React.createElement("p", {
      className: styles.personName
    }, get(person, "related_person.name", "")), /*#__PURE__*/React.createElement("p", {
      className: styles.personLifeSpan
    }, get(person, "related_person.lifespan", "")))), !isBlank(person === null || person === void 0 || (_person$related_perso = person.related_person) === null || _person$related_perso === void 0 ? void 0 : _person$related_perso.biography) ? /*#__PURE__*/React.createElement(WaterfallFlowList, {
      componentName: "TopicWithRelatedPeople",
      list: get(person, "related_person.biography", [])
    }) : /*#__PURE__*/React.createElement(Empty, {
      image: Empty.PRESENTED_IMAGE_SIMPLE,
      className: styles.empty
    }));
  })));
}